import { render, staticRenderFns } from "./forca-trabalho.vue?vue&type=template&id=b6cc8e1a&scoped=true"
import script from "./forca-trabalho.vue?vue&type=script&lang=js"
export * from "./forca-trabalho.vue?vue&type=script&lang=js"
import style0 from "./forca-trabalho.vue?vue&type=style&index=0&id=b6cc8e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cc8e1a",
  null
  
)

export default component.exports